module.exports = __webpack_public_path__ + "img/product_15.10e3cab.webp";